import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumb, Icon } from 'antd'
import '../assets/css/fundService.css'
// import  serviceConstruct from '../assets/images/fundConstruct.svg'
import trustService from '../assets/images/trustService.svg'
import fundGraph from '../assets/images/fundGraph.png'


class FundService extends Component {
    render () {
        return (
            <div>
                <div className="banner-item banner-fund">
                    <div className="l-container">
                        <h2>基金服务</h2>
                    </div>
                </div>
                <div className="page-title l-container">
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item><a href="/gs/">首页</a></Breadcrumb.Item>
                        <Breadcrumb.Item><a href="/gs/business/">我们的业务</a></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to="/">资产托管与基金服务</Link></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to="/assetTrust">基金服务</Link></Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className="page-content-fund">
                    <div className="content-panel">
                        <div className="l-container">
                            <h2>基金服务</h2>
                            <div className="fund-service-box">
                                <div>
                                基金服务业务是指我司作为第三方机构，接受资产管理机构委托，为资产管理机构提供份额登记、估值核算等后台运营服务。
                                </div>
                                <div>
                                    <div className="img-wrap">
                                        <img src={fundGraph} alt="fundGraph"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content-panel">
                        <div className="l-container">
                            <h2>服务内容</h2>
                            <div className="service-content-box">
                                <div>
                                    <div className="box-item">
                                        <h4>募集账户资金监督</h4>
                                        <p>可提供募集账户开立、募集账户资金监管、募集账户核对等监督服务</p>
                                    </div>
                                    <div className="box-item">
                                        <h4>份额登记</h4>
                                        <p>可支持基金高水位法、单人单笔业绩报酬计提、虚拟净值、预提式业绩报酬、母子联动申赎等各类型产品</p>
                                    </div>
                                </div>
                                <div>
                                    <div className="box-item">
                                        <h4>估值核算</h4>
                                        <p>提供目前国内市场所有投资品种及海外主要投资品种估值核算；支持包括主动管理型、结构化分级产品、FOF母子基金、指数基金、现金管理型基金等不同产品结构的估值核算；支持T+0估值</p>
                                    </div>
                                    <div className="box-item">
                                        <h4>协助信息披露和季度信息更新</h4>
                                        <p>可提供月报、季报、年报等私募基金信息披露报表制定以及季度信息更新内容下载</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="content-panel" disable>
                        <div className="l-container">
                            <h2>基金服务架构</h2>
                            <div className="service-construct">
                                <img src={serviceConstruct} alt="serviceConstruct"/>
                            </div>
                        </div>
                    </div> */}
                    <div className="content-panel">
                    </div>
                    <div className="content-panel">
                        <div className="l-container">
                            <h2>业务资格</h2>
                            <div className="service-qualification">
                                <div>
                                    <img src={trustService} alt="trustService"/>
                                    <p>
                                    国信证券是首批获得证券投资基金业协会《私募基金业务外包服务机构备案证明》【备案编号A00003】的券商之一。目前合作服务的资产管理机构已近3000家，凭借创新能力和综合服务优势，为各类资产管理机构提供一站式PB业务综合服务解决方案。
                                    </p>
                                </div>
                                <div>
                                    <div className="ant-btn"><a href="http://fo.amac.org.cn/amac/allNotice.do">查看业务资格<Icon type="right" /></a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default FundService
